import { push, replace } from 'connected-react-router';
import { Action, Types } from './types';
export const Actions = {
  push,
  replace,

  /**
   * Replace the current query string with the contents of the new query.
   */
  replaceQuery: (query: { [key: string]: string }, replacePath = true): Action => ({
    type: Types.REPLACE_QUERY,
    payload: {
      query,
      replacePath,
    },
  }),

  /**
   * Update the current query string.
   */

  updateQuery: (query: { [key: string]: string }, replacePath = false): Action => ({
    type: Types.UPDATE_QUERY,
    payload: {
      query,
      replacePath,
    },
  }),
};
